// src/pages/LinkedInRedirect.tsx or routes/LinkedInRedirect.tsx
import { useEffect } from "react";

const LinkedInRedirect = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const state = params.get("state");

    if (code && state === "ica-conference") {
      fetch("https://us-central1-icaconference-438ba.cloudfunctions.net/postLinkedIn", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ code }),
      })
        .then((res) => res.json())
        .then((res) => {
          if (res.success) {
            alert("✅ Posted to LinkedIn!");
          } else {
            alert("❌ LinkedIn post failed.");
          }
          window.location.href = "/";
        })
        .catch(() => {
          alert("❌ LinkedIn request failed.");
          window.location.href = "/";
        });
    }
  }, []);

  return <p>Posting to LinkedIn...</p>;
};

export default LinkedInRedirect;
